const routes = {
  welcome: '/welcome',
  timeline: '/timeline',
  question: '/question'
};

export default routes;
